module.exports = __webpack_public_path__ + "img/block.a0e73919.svg";